export enum DeliveryTimeType {
    Exact = 'exact',
    Window = 'window',
}
